var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7854_70392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM8.77026 8.86364V14.7718C8.80096 15.0768 8.94142 15.3603 9.1655 15.5695C9.38959 15.7787 9.68203 15.8994 9.98844 15.9091C10.3001 15.9184 10.6028 15.8042 10.8306 15.5914C11.0585 15.3785 11.193 15.0843 11.2048 14.7727V8.86364C11.1739 8.55908 11.0337 8.27606 10.81 8.06709C10.5863 7.85812 10.2944 7.73738 9.98844 7.72727C9.67648 7.71744 9.3733 7.83142 9.14508 8.04432C8.91685 8.25721 8.78211 8.55175 8.77026 8.86364ZM9.03602 4.03576C8.78029 4.29149 8.63662 4.63834 8.63662 5C8.62904 5.1811 8.65913 5.3618 8.72497 5.53068C8.79082 5.69955 8.891 5.85292 9.01917 5.98109C9.14734 6.10926 9.30071 6.20944 9.46958 6.27528C9.63846 6.34113 9.81916 6.37122 10.0003 6.36364C10.1814 6.37122 10.3621 6.34113 10.5309 6.27528C10.6998 6.20944 10.8532 6.10926 10.9813 5.98109C11.1095 5.85292 11.2097 5.69955 11.2755 5.53068C11.3414 5.3618 11.3715 5.1811 11.3639 5C11.3639 4.63834 11.2202 4.29149 10.9645 4.03576C10.7088 3.78003 10.3619 3.63636 10.0003 3.63636C9.6386 3.63636 9.29175 3.78003 9.03602 4.03576Z",
    fill: "var(--icon-primary-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7854_70392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoTooltip);
export default __webpack_public_path__ + "static/media/ic_info_tooltip.1c6dd9d115ecf30be6c979b6347f3dce.svg";
export { ForwardRef as ReactComponent };